<template>
  <BasePage :pageTitle=__DICT__.bottomMenu.handbook show-menu show-footer>
    <div class="mt-6 text-center" v-if="!__DICT__.handbookURLs">
      <a :href="__DICT__.handbookURL" target="_blank" class="btn-primary btn">{{ __DICT__.view }} {{__DICT__.bottomMenu.handbook}}</a>
    </div>
    <div class="mt-6 text-center" v-if="__DICT__.handbookURLs">
      <div class="mb-2" v-for="hb in handbookURLs">
        <a :href="hb.url" target="_blank" class="btn-primary btn">{{hb.name}}</a>
      </div>
    </div>
  </BasePage>
</template>
<script setup>
import BasePage from "@/components/BasePage.vue";
import {useRouter} from "vue-router";
const router = useRouter();
const handbookURLs = __DICT__.handbookURLs
const navigateTo = (route) => {
  router.push({ name: route });
};
</script>